export default {"src":"/_next/static/media/Help.f9b91609.svg","height":16,"width":16};